import React from 'react';
import EllipseControl from '../../../../../../Common/EllipsesControl/EllipsesControl';
import styled from 'styled-components';

const CustomHeader = ({displayName, noOfLines, className}) => {
	return (
		<StyledCustomHeader className={className}>
			<EllipseControl content={displayName} tooltip={displayName} noOfLines={noOfLines ?? 1} />
		</StyledCustomHeader>
	);
};

export default CustomHeader;

const StyledCustomHeader = styled.section`
	display: flex;
	width: 100%;

	.ellipses {
		font-size: var(--px-14);
		padding: var(--px-10) 0 var(--px-10) 0;
	}
`;
